/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ManagementLevelEnum = 'Abteilungsleitung' | 'Geschaeftsbereichsleitung' | 'Geschaeftsleitung' | 'Niederlassungsleitung' | 'Regionalleitung' | 'Teamleitung' | 'KeineLeitung';

export const ManagementLevelEnum = {
    Abteilungsleitung: 'Abteilungsleitung' as ManagementLevelEnum,
    Geschaeftsbereichsleitung: 'Geschaeftsbereichsleitung' as ManagementLevelEnum,
    Geschaeftsleitung: 'Geschaeftsleitung' as ManagementLevelEnum,
    Niederlassungsleitung: 'Niederlassungsleitung' as ManagementLevelEnum,
    Regionalleitung: 'Regionalleitung' as ManagementLevelEnum,
    Teamleitung: 'Teamleitung' as ManagementLevelEnum,
    KeineLeitung: 'KeineLeitung' as ManagementLevelEnum
};

